<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      search_route="/multi_google_meals/add"
      search_title="اضافه وجبات"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->
    <!-- <main-filter @getResult="setRows" dateStart dateEnd startAt code /> -->
    <transition name="fadeInUp" mode="out-in" v-if="loaderPage">
      <MainLoader />
    </transition>

    <div class="fadeIn" v-else>
      <!-- Start Main Section -->
      <!-- <MainFilter
        @getResult="setRows($event)"
        :meals_name="true"
        dateStart
        dateEnd
      /> -->
      <the-filter :inputs="inputs" />

      <main class="magic-table-wrapper">
        <v-data-table
          class="thumb strip"
          :headers="headers"
          :items="rows"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Start:: Users Routes -->

          <template v-slot:[`item.images`]="{ item }">
            <div class="image" v-if="item.image">
              <img :src="item.image" alt="" @click="show_model_1" />
            </div>
          </template>

          <template v-slot:[`item.type`]="{ item }">
            <span>
              {{ item.type == "amount" ? "قيمة" : "شحن مجاني" }}
            </span>
          </template>
          <template v-slot:[`item.discount_type`]="{ item }">
            <span>
              {{ item.discount_type == "amount" ? "قيمة" : "نسبة" }}
            </span>
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
              {{ item.is_active ? "فعال" : "غير فعال" }}
            </span>
          </template>
          <template v-slot:[`item.discound`]="{ item }">
            <div class="card-table border-0">
              <div class="details p-0">
                <h4>
                  <span>قيمه الخصم:</span>
                  {{ item.discount_amount }}
                  {{ item.discount_type == "percentage" ? "%" : "" }}
                </h4>

                <h4>
                  <span>اقصي عدد مستخدمين للخصم:</span>
                  {{ item.max_used_for_user }}
                </h4>
              </div>
            </div>
          </template>
          <!-- <template v-slot:[`item.is_active`]="{ item }">
            <v-btn
              @click="toggleStatusModel(item)"
              :color="item.is_active ? 'success' : 'error'"
              >{{ item.is_active ? "فعال" : "غير فعال" }}</v-btn
            >
          </template> -->
          <template v-slot:[`item.store_btn`]="{ item }">
            <v-btn @click="showStoresJoiningTheOffer(item.id)" class="primary"
              >عرض</v-btn
            >
          </template>

          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length" class="creative-expand-td">
              <div class="creative-expand-card fadeIn">
                <!-- Top Decorative Gradient Glow Line -->
                <div class="creative-glow-bar"></div>

                <!-- Header Bar -->
                <div class="expand-header">
                  <div class="header-main-info">
                    <div class="header-icon-box">
                      <i class="fal fa-utensils-alt"></i>
                    </div>
                    <div class="header-text-group">
                      <div class="header-title-row">
                        <h4 class="expand-title">
                          المطاعم المشتركة في هذه الوجبة
                        </h4>
                        <span
                          class="count-badge"
                          v-if="!rows2Loading && rows2.length"
                        >
                          <i class="fal fa-store"></i>
                          {{ formatRestaurantCount(rows2.length) }}
                        </span>
                      </div>
                      <div class="header-sub-meta">
                        <span
                          class="sub-chip meal-name"
                          v-if="expandData && expandData.name"
                        >
                          <i class="fal fa-burger-soda"></i>
                          {{ expandData.name }}
                        </span>
                        <span
                          class="sub-chip unique-num"
                          v-if="expandData && expandData.unique_number"
                        >
                          <i class="fal fa-fingerprint"></i>
                          #{{ expandData.unique_number }}
                        </span>
                        <span
                          class="sub-chip menu-name"
                          v-if="
                            expandData &&
                            expandData.menu &&
                            expandData.menu.name
                          "
                        >
                          <i class="fal fa-folder-open"></i>
                          {{ expandData.menu.name }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Right Controls -->
                  <div class="header-controls">
                    <!-- Refresh Button -->
                    <button
                      type="button"
                      class="btn-expand-refresh"
                      @click="refreshRows2"
                      :disabled="rows2Loading"
                      title="تحديث البيانات"
                    >
                      <i
                        class="fal fa-sync-alt"
                        :class="{ 'fa-spin': rows2Loading }"
                      ></i>
                    </button>
                  </div>
                </div>

                <!-- Body Content -->
                <div class="expand-body">
                  <!-- 1. Empty State -->
                  <div
                    v-if="!rows2Loading && !rows2.length"
                    class="creative-empty-state"
                  >
                    <div class="empty-icon-circle">
                      <i class="fal fa-store-slash"></i>
                    </div>
                    <h5>لا توجد مطاعم مشتركة مسجلة لهذه الوجبة حالياً</h5>
                    <p>
                      يمكنك تعديل بيانات الوجبة وإضافة المطاعم المشتركة إليها
                      بسهولة
                    </p>
                    <button
                      type="button"
                      class="btn-creative-action"
                      v-if="expandData && expandData.id"
                      @click="editItem(expandData)"
                    >
                      <i class="fal fa-plus-circle"></i>
                      <span>تعديل الوجبة وربط مطاعم</span>
                    </button>
                  </div>

                  <!-- 2. Modern Creative Table View (Table Only) -->
                  <div v-else class="creative-table-responsive">
                    <table class="creative-modern-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>المطعم</th>
                          <th>اسم الوجبة بالمطعم</th>
                          <th>القائمة</th>
                          <th>السعر</th>
                          <th>تاريخ الإنشاء</th>
                          <th class="text-center">تعديل</th>
                        </tr>
                      </thead>
                      <tbody v-if="rows2Loading">
                        <tr
                          v-for="n in 3"
                          :key="'skel-' + n"
                          class="skeleton-tr"
                        >
                          <td colspan="7">
                            <div
                              class="skeleton-table-bar skeleton-shimmer"
                            ></div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr v-for="(row, rIdx) in rows2" :key="row.id || rIdx">
                          <td class="td-index">
                            <span class="index-circle">{{ rIdx + 1 }}</span>
                          </td>
                          <td class="td-restaurant">
                            <div class="table-restaurant-cell">
                              <div class="table-store-logo">
                                <img
                                  v-if="
                                    row.restaurant &&
                                    (row.restaurant.store_image ||
                                      row.restaurant.image)
                                  "
                                  :src="
                                    row.restaurant.store_image ||
                                    row.restaurant.image
                                  "
                                  :alt="row.restaurant.name"
                                  @error="
                                    (e) => (e.target.style.display = 'none')
                                  "
                                />
                                <i v-else class="fal fa-store"></i>
                              </div>
                              <div class="table-store-info">
                                <router-link
                                  v-if="row.restaurant && row.restaurant.id"
                                  :to="`/store/show/${row.restaurant.id}`"
                                  class="table-store-link"
                                  :title="
                                    'زيارة صفحة ' +
                                    (row.restaurant.name || 'المتجر')
                                  "
                                >
                                  <span>{{ row.restaurant.name }}</span>
                                  <i class="fal fa-external-link-alt"></i>
                                </router-link>
                                <span v-else class="table-store-name">{{
                                  (row.restaurant && row.restaurant.name) ||
                                  "---"
                                }}</span>
                              </div>
                            </div>
                          </td>
                          <td class="td-meal-name">
                            <div class="table-meal-cell">
                              <i
                                class="fal fa-drumstick-bite meal-cell-icon"
                              ></i>
                              <span class="font-weight-600">{{
                                row.name
                              }}</span>
                            </div>
                          </td>
                          <td class="td-menu">
                            <span
                              class="table-pill pill-menu"
                              v-if="row.menu && row.menu.name"
                            >
                              <i class="fal fa-layer-group"></i>
                              {{ row.menu.name }}
                            </span>
                            <span v-else class="text-muted">---</span>
                          </td>
                          <td class="td-price">
                            <span
                              class="table-pill pill-price"
                              v-if="
                                row.price !== undefined &&
                                row.price !== null &&
                                row.price !== ''
                              "
                            >
                              {{ row.price }} ر.س
                            </span>
                            <span v-else class="text-muted">---</span>
                          </td>
                          <td class="td-date">
                            <div class="table-date-cell">
                              <i class="fal fa-calendar-alt"></i>
                              <span>{{ row.created_at || "---" }}</span>
                            </div>
                          </td>
                          <td class="td-actions text-center">
                            <button
                              type="button"
                              class="btn-table-edit"
                              @click="editProduct(row)"
                              title="تعديل الوجبة في المطعم"
                            >
                              <i class="fal fa-edit"></i>
                              <span>تعديل</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.extendIcon`]="{ item }">
            <div class="_actions">
              <bdi>
                {{ $t("labels.showData") }}
              </bdi>
              <v-icon class="show" small @click="clickRow(item)">
                fas fa-angle-double-down
              </v-icon>
            </div>
          </template>

          <!-- Start:: Report Reason Modal Button -->
          <template v-slot:[`item.report_reason`]="{ item }">
            <v-icon class="show" small v-if="item.report_reason">
              fal fa-eye
            </v-icon>

            <span v-else>_</span>
          </template>
          <!-- <template v-slot:[`item.restaurants`]="{ item }">
            <button >{{}}</button>
          </template> -->
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <!-- <v-icon class="show" small @click="showItem(item)">
                fal fa-eye
              </v-icon> -->
              <v-icon
                class="show"
                small
                @click="editItem(item)"
                v-if="helper_hasPermission('edit')"
              >
                fal fa-edit
              </v-icon>

              <v-icon
                class="delete"
                small
                @click="deleteItem(item)"
                v-if="helper_hasPermission('delete')"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="table-title title">الوجبات</h3>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <section class="table-buttons d-inline-flex p-0 mb-5">
              <button @click="getAllMeals()" class="button_delete ml-5">
                تحميل جميع الوجبات
              </button>
              <!-- <export-excel
                v-if="selected.length > 0"
                :data="selected"
                :fields="jsonFields"
                name="المتاجر.xlsx"
                type="xls"
                class="button_delete ml-5"
              >
                تحميل Excel
              </export-excel> -->
            </section>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>

      <!-- End Statistics Card-->

      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container text-center mb-5 d-flex justify-content-end"
        >
          <div class="select-pagination d-flex">
            <span class="first">{{ $t('show') }}</span>
            <v-select
              :items="[10, 25, 50, 100]"
              v-model="paginations.items_per_page"
              @change="onPerPageChange"
            ></v-select>
            <span>{{ $t('entries') }}</span>
          </div>

          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
    </div>
    <v-dialog v-model="statusModel" width="500">
      <v-card class="p-4" v-if="statusItem">
        <h5 v-if="statusItem.is_active">هو تود الغاء تفعيل هذا المتجر؟</h5>
        <h5 v-else>هو تود تفعيل هذا المتجر؟</h5>

        <textarea
          v-if="statusItem.is_active"
          v-model="deactive_reason"
          placeholder="السبب ..."
          class="deactive_reason mt-5 px-3"
        ></textarea>
        <div class="text-center mt-5">
          <v-btn
            class="ml-2 px-10"
            @click="changeStatus"
            :color="statusItem.is_active ? 'error' : 'success'"
            >نعم</v-btn
          >
          <v-btn
            class="mr-2 px-10"
            @click="statusModel = false"
            :color="statusItem.is_active ? 'success' : 'error'"
            >لا</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="storesDialog">
      <v-card class="p-2">
        <MainLoader v-if="isStoresLoading"></MainLoader>
        <main v-else>
          <v-data-table
            class="thumb strip"
            :headers="storesheaders"
            :items="stores"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading_table"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- ====== Select row field ====== -->
            <!-- Image -->
            <template v-slot:[`item.store`]="{ item }">
              <div v-if="item.store">
                <img
                  @click="show_model_1"
                  class="image"
                  :src="item.store.store_image"
                />
                <div class="mt-1">{{ item.store.trad_name }}</div>
              </div>
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <template v-slot:[`item.extendIcon`]="{ item }">
              <div class="_actions">
                <bdi>
                  {{ $t("labels.showData") }}
                </bdi>
                <v-icon class="show" small @click="clickRow(item)">
                  fas fa-angle-double-down
                </v-icon>
              </div>
            </template>

            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <router-link :to="`/store/show/${item.id}`">
                  <v-icon class="show" small> fal fa-eye </v-icon>
                </router-link>
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <h3 class="table-title title">المتاجر المشتركة</h3>
              <!-- Delete dialog -->

              <section class="table-buttons d-inline-flex p-0">
                <button @click="getAllMeals" class="button_delete ml-5">
                  تحميل جميع الوجبات
                </button>
                <export-excel
                  v-if="selected.length > 0"
                  :data="selected"
                  :fields="jsonFields"
                  name="meals.csv"
                  type="csv"
                  class="button_delete ml-5"
                >
                  تحميل Excel
                </export-excel>
              </section>
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main></v-card
      >
    </v-dialog>
    <!-- Delete dialog -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MainLoader from "../../../components/Loaders/MainLoader.vue";
import theFilter from "@/components/Filters/TheFilter.vue";

export default {
  components: { MainLoader, theFilter },
  data() {
    return {
      loading: false,
      loading_table: false,
      loaderPage: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.meals.title"),
          disabled: false,
          href: "/multi_google_meals",
        },
        {
          text: this.$t("breadcrumb.meals.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      statusModel: false,
      statusItem: null,

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created
      rows2: [], // injected in created

      stores: [],

      // ========== elected Data
      selected: [],
      singleSelect: false,
      expanded: [],
      singleExpand: false,
      expandData: {},
      rows2Loading: false,
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      lodaing: false,
      isStoresLoading: false,
      storesDialog: false,

      // ========== Filter
      inputs: [
        {
          keyName: "keyword",
        },
        // {
        //   keyName: "meal",
        // },
        {
          keyName: "start_date",
          value: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            2
          )
            .toISOString()
            .slice(0, 10),
        },
        {
          keyName: "end_date",
          value: new Date().toISOString().slice(0, 10),
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "الصوره",
            align: "center",
            value: "images",
            height: "80",
            sortable: true,
          },

          {
            text: "الاسم",
            align: "center",
            value: "name",
            sortable: true,
          },
          // {
          //   text: "الوصف",
          //   align: "center",
          //   value: "desc",
          //   sortable: true,
          // },

          // {
          //   text: "الدولة",
          //   align: "center",
          //   value: "country.ar.name",
          //   sortable: true,
          // },
          {
            text: "القائمة",
            align: "center",
            value: "menu.name",
            sortable: true,
          },
          {
            text: "مفعل ",
            align: "start",
            value: "is_active",

            sortable: true,
          },
          {
            text: "تفاصيل اضافيه",
            align: "start",
            value: "extendIcon",

            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "start",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    headers2() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "الصوره",
            align: "center",
            value: "images",
            height: "80",
            sortable: true,
          },

          {
            text: "الاسم",
            align: "center",
            value: "name",
            sortable: true,
          },
          // {
          //   text: "الوصف",
          //   align: "center",
          //   value: "desc",
          //   sortable: true,
          // },

          // {
          //   text: "الدولة",
          //   align: "center",
          //   value: "country.ar.name",
          //   sortable: true,
          // },
          {
            text: "القائمة",
            align: "center",
            value: "menu.name",
            sortable: true,
          },
          {
            text: "تاريخ الانشاء",
            align: "center",
            value: "created_at",
            sortable: true,
          },
          {
            text: "مفعل ",
            align: "start",
            value: "is_active",

            sortable: true,
          },
          {
            text: "تفاصيل اضافيه",
            align: "start",
            value: "expand_btn",

            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "start",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    storesheaders() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "المتجر",
            align: "center",
            value: "store",
            sortable: false,
          },
          {
            text: "نوع المتجر",
            value: "store.place_category.name",
            align: "center",
          },
          {
            text: "المالك",
            value: "full_name",
            align: "center",
          },
          {
            text: "رقم الهاتف",
            value: "phone_complete_form",
            align: "center",
          },
          // {
          //   text: "البريد الالكتروني",
          //   value: "email",
          //   align: "center",
          // },

          {
            text: "بيانات المتجر",
            value: "is_admin_accept",
            align: "center",
          },
          {
            text: "الحالة",
            value: "is_ban",
            align: "center",
          },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "image",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Name", value: "fullname", align: "center" },
          { text: "Followers", value: "followers_count", align: "center" },
          { text: "Following", value: "followings_count", align: "center" },
          {
            text: "Active",
            value: "is_active",
            align: "center",
          },
          {
            text: "Permission",
            value: "role",
            align: "center",
          },
          {
            text: "control",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
    keyword() {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword;
      } else {
        return "";
      }
    },
    meals_name() {
      if (this.$route.query.meals_name) {
        return this.$route.query.meals_name;
      } else {
        return "";
      }
    },
    jsonFields() {
      return {
        الاسم: "name",
        "الرقم المميز": "unique_number",
        القائمة: "menu.ar.name",
        "حالة التفعيل": "is_active",
        "تاريخ الانشاء": "created_at",
      };
    },
  },

  watch: {
    $route: {
      handler() {
        this.handleRouteChange();
      },
      immediate: true, // This will make the watcher run when the component is created
    },
  },

  methods: {
    clickRow(rowData) {
      if (this.noExpand) return;
      const indexExpanded = this.expanded.findIndex((i) => i === rowData);
      if (indexExpanded > -1) {
        // Exisit
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expandData = rowData;
        this.setRows2(rowData);
        this.expanded = [];
        this.expanded.push(rowData);
        // this.mapItem(rowData);
      }
    },
    toggleStatusModel(item) {
      this.statusModel = true;
      this.statusItem = item;
    },
    changeStatus() {
      if (this.statusItem.is_active && !this.deactive_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الغاء التفعيل اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      const formData = new FormData();
      formData.append("is_active", this.statusItem.is_active ? 0 : 1);
      if (this.deactive_reason) {
        formData.append("message", this.deactive_reason);
      }
      formData.append("_method", "PUT");

      /* eslint-disable */console.log(...oo_oo(`2348627034_840_6_840_34_4`,this.statusItem));
      this.$axios({
        method: "POST",
        url: `/Offer/is_active/${this.statusItem.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.setRows();
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    async showStoresJoiningTheOffer(id) {
      this.storesDialog = true;
      this.isStoresLoading = true;
      const { data } = await this.$axios.get(`offer/${id}/restaurants`);
      this.isStoresLoading = false;
      this.isStoresLoading = false;
      this.stores = data.data;
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/multi_google_meals/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/multi_google_meals/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({
        path: "/multi_google_meals/edit/" + item.id + "/" + item.unique_number,
      });
    },
    editProduct(item) {
      this.$router.push({
        path: `/googlePlace/show_google_place/${item.restaurant?.id}/place_id/${item.restaurant?.place_categeory_id}/edit/${item.id}`,
      });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `delete_multi_google_meals/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.$axios({
        method: "POST",
        url: `coupon/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "get_multi_google_meals",
        params: {
          keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
          page: this.paginations.current_page,
          per_page: this.paginations.items_per_page,
          created_from: this.$route.query.start_date
            ? this.$route.query.start_date
            : this.inputs.find((el) => el.keyName == "start_date")?.value || "",
          created_to: this.$route.query.end_date
            ? this.$route.query.end_date
            : this.inputs.find((el) => el.keyName == "end_date")?.value || "",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page || 1;
          this.paginations.items_per_page = res.data.meta?.per_page || 20;
          this.statisticsItem.number = res.data.meta?.total || 0;
          this.rows = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setRows2(item) {
      if (!item || !item.unique_number) return;

      this.rows2 = [];
      this.rows2Loading = true;
      this.$axios({
        method: "GET",
        url: `meals/${item.unique_number}/google/multiple/with_restaurants`,
      })
        .then((res) => {
          this.rows2 = res.data.data || [];
          this.rows2Loading = false;
        })
        .catch(() => {
          this.rows2 = [];
          this.rows2Loading = false;
        });
    },
    refreshRows2() {
      if (this.expandData && this.expandData.unique_number) {
        this.setRows2(this.expandData);
      }
    },
    formatRestaurantCount(count) {
      if (!count) return "";
      if (count === 1) return "مطعم واحد";
      if (count === 2) return "مطعمان";
      if (count <= 10) return `${count} مطاعم`;
      return `${count} مطعم`;
    },
    getAllMeals() {
      this.$axios({
        url: "meal/export",
        method: "POST",
        data: {
          is_belong_partner_store: 0,
        },
        params: {
          keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
          page: this.paginations.current_page,
          created_from: this.$route.query.start_date
            ? this.$route.query.start_date
            : new Date(new Date().getFullYear(), new Date().getMonth() - 1, 2)
                .toISOString()
                .slice(0, 10),
          created_to: this.$route.query.end_date
            ? this.$route.query.end_date
            : new Date().toISOString().slice(0, 10),
        },
        // responseType: "blob", // Important
      }).then((res) => {
        this.$iziToast.success({
          timeout: 2000,
          message: res.data.message,
          position: "bottomRight",
        });
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "file.xlsx"); //or any other extension
        // document.body.appendChild(link);
        // link.click();
      });
    },
    fetchData(e) {
      // Only update route, handleRouteChange will handle the rest
      this.$router.push({
        query: { ...this.$route.query, page: e },
      });
    },
    onPerPageChange() {
      this.paginations.current_page = 1;
      this.setRows();
    },

    handleRouteChange() {
      // Check for missing filter parameters in route query
      let queryNeedsUpdate = false;
      let newQuery = { ...this.$route.query };

      const defaultStartDate = this.inputs.find((el) => el.keyName == "start_date").value;
      const defaultEndDate = this.inputs.find((el) => el.keyName == "end_date").value;

      if (newQuery.start_date === undefined) {
        newQuery.start_date = defaultStartDate;
        queryNeedsUpdate = true;
      }
      if (newQuery.end_date === undefined) {
        newQuery.end_date = defaultEndDate;
        queryNeedsUpdate = true;
      }

      if (queryNeedsUpdate) {
        // Replace the route to include the default filters without adding to history
        this.$router.replace({ query: newQuery }).catch(() => {});
        return; // The route change will trigger this watcher again
      }

      // Only handle the page parameter for this component
      const { page } = this.$route.query;

      // Update pagination
      this.paginations.current_page = page ? +page : 1;

      // Call setRows with nextTick to ensure all data is updated
      this.$nextTick(() => {
        this.setRows();
      });
    },

    smeth() {
      /* eslint-disable */console.log(...oo_oo(`2348627034_1076_6_1076_23_4`,"ss"));
    },
  },

  created() {
    // Initialize with current route parameters
    this.handleRouteChange();
  },

  // ======= hooks
};
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x3bccce=_0x3f31;(function(_0x4cc790,_0x57b2ac){var _0x249599=_0x3f31,_0x59d275=_0x4cc790();while(!![]){try{var _0x4ad8ab=-parseInt(_0x249599(0x17f))/0x1*(-parseInt(_0x249599(0xbb))/0x2)+parseInt(_0x249599(0x168))/0x3*(-parseInt(_0x249599(0x122))/0x4)+-parseInt(_0x249599(0x141))/0x5+-parseInt(_0x249599(0x106))/0x6+-parseInt(_0x249599(0x18f))/0x7*(-parseInt(_0x249599(0x1ad))/0x8)+parseInt(_0x249599(0xc9))/0x9*(-parseInt(_0x249599(0x10b))/0xa)+parseInt(_0x249599(0x13a))/0xb*(parseInt(_0x249599(0xb6))/0xc);if(_0x4ad8ab===_0x57b2ac)break;else _0x59d275['push'](_0x59d275['shift']());}catch(_0x238842){_0x59d275['push'](_0x59d275['shift']());}}}(_0x5e98,0x88d83));function z(_0x4341e0,_0x59fdda,_0x255161,_0x5a3dd8,_0xbceddf,_0x39681f){var _0x3b658c=_0x3f31,_0x9a39a1,_0x415d78,_0x45fe4d,_0x4c8890;this[_0x3b658c(0xcc)]=_0x4341e0,this[_0x3b658c(0xf3)]=_0x59fdda,this[_0x3b658c(0x165)]=_0x255161,this[_0x3b658c(0x11b)]=_0x5a3dd8,this[_0x3b658c(0x159)]=_0xbceddf,this[_0x3b658c(0x1ba)]=_0x39681f,this['_allowedToSend']=!0x0,this[_0x3b658c(0x1c0)]=!0x0,this[_0x3b658c(0x130)]=!0x1,this['_connecting']=!0x1,this[_0x3b658c(0xe4)]=((_0x415d78=(_0x9a39a1=_0x4341e0[_0x3b658c(0x161)])==null?void 0x0:_0x9a39a1[_0x3b658c(0x19c)])==null?void 0x0:_0x415d78[_0x3b658c(0xc7)])===_0x3b658c(0xee),this[_0x3b658c(0xdc)]=!((_0x4c8890=(_0x45fe4d=this[_0x3b658c(0xcc)]['process'])==null?void 0x0:_0x45fe4d['versions'])!=null&&_0x4c8890[_0x3b658c(0xf0)])&&!this[_0x3b658c(0xe4)],this[_0x3b658c(0x18c)]=null,this[_0x3b658c(0x155)]=0x0,this[_0x3b658c(0xc2)]=0x14,this['_webSocketErrorDocsLink']='https://tinyurl.com/37x8b79t',this['_sendErrorMessage']=(this[_0x3b658c(0xdc)]?_0x3b658c(0xcf):'Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20')+this[_0x3b658c(0x16e)];}z[_0x3bccce(0x146)][_0x3bccce(0x134)]=async function(){var _0x2d59ec=_0x3bccce,_0x32ce43,_0x3dd5b7;if(this[_0x2d59ec(0x18c)])return this[_0x2d59ec(0x18c)];let _0x191a2b;if(this[_0x2d59ec(0xdc)]||this['_inNextEdge'])_0x191a2b=this['global'][_0x2d59ec(0xc6)];else{if((_0x32ce43=this['global'][_0x2d59ec(0x161)])!=null&&_0x32ce43[_0x2d59ec(0x127)])_0x191a2b=(_0x3dd5b7=this[_0x2d59ec(0xcc)][_0x2d59ec(0x161)])==null?void 0x0:_0x3dd5b7[_0x2d59ec(0x127)];else try{_0x191a2b=(await new Function(_0x2d59ec(0x185),_0x2d59ec(0x1c5),_0x2d59ec(0x11b),_0x2d59ec(0x179))(await(0x0,eval)(_0x2d59ec(0x16a)),await(0x0,eval)('import(\\x27url\\x27)'),this['nodeModules']))[_0x2d59ec(0x18e)];}catch{try{_0x191a2b=require(require(_0x2d59ec(0x185))[_0x2d59ec(0x100)](this[_0x2d59ec(0x11b)],'ws'));}catch{throw new Error(_0x2d59ec(0x196));}}}return this[_0x2d59ec(0x18c)]=_0x191a2b,_0x191a2b;},z[_0x3bccce(0x146)][_0x3bccce(0x1a8)]=function(){var _0x1327c2=_0x3bccce;this[_0x1327c2(0x174)]||this[_0x1327c2(0x130)]||this[_0x1327c2(0x155)]>=this[_0x1327c2(0xc2)]||(this[_0x1327c2(0x1c0)]=!0x1,this[_0x1327c2(0x174)]=!0x0,this[_0x1327c2(0x155)]++,this[_0x1327c2(0x12e)]=new Promise((_0x5c923b,_0x1aba26)=>{var _0x2265d2=_0x1327c2;this[_0x2265d2(0x134)]()[_0x2265d2(0xf4)](_0x138923=>{var _0x3544da=_0x2265d2;let _0x5b4d2a=new _0x138923(_0x3544da(0x11c)+(!this[_0x3544da(0xdc)]&&this[_0x3544da(0x159)]?_0x3544da(0x177):this[_0x3544da(0xf3)])+':'+this[_0x3544da(0x165)]);_0x5b4d2a[_0x3544da(0xb7)]=()=>{var _0x52be26=_0x3544da;this[_0x52be26(0x17e)]=!0x1,this[_0x52be26(0xd5)](_0x5b4d2a),this['_attemptToReconnectShortly'](),_0x1aba26(new Error(_0x52be26(0x188)));},_0x5b4d2a['onopen']=()=>{var _0x4c14a1=_0x3544da;this[_0x4c14a1(0xdc)]||_0x5b4d2a[_0x4c14a1(0xec)]&&_0x5b4d2a[_0x4c14a1(0xec)]['unref']&&_0x5b4d2a[_0x4c14a1(0xec)][_0x4c14a1(0x1ae)](),_0x5c923b(_0x5b4d2a);},_0x5b4d2a[_0x3544da(0xea)]=()=>{var _0x24ebec=_0x3544da;this[_0x24ebec(0x1c0)]=!0x0,this[_0x24ebec(0xd5)](_0x5b4d2a),this[_0x24ebec(0x1c2)]();},_0x5b4d2a[_0x3544da(0x14e)]=_0x3fc7f1=>{var _0x25c89e=_0x3544da;try{if(!(_0x3fc7f1!=null&&_0x3fc7f1[_0x25c89e(0xd1)])||!this[_0x25c89e(0x1ba)])return;let _0x2ab68a=JSON[_0x25c89e(0xe8)](_0x3fc7f1[_0x25c89e(0xd1)]);this[_0x25c89e(0x1ba)](_0x2ab68a[_0x25c89e(0x19a)],_0x2ab68a[_0x25c89e(0x186)],this[_0x25c89e(0xcc)],this[_0x25c89e(0xdc)]);}catch{}};})[_0x2265d2(0xf4)](_0x1f2633=>(this[_0x2265d2(0x130)]=!0x0,this[_0x2265d2(0x174)]=!0x1,this[_0x2265d2(0x1c0)]=!0x1,this['_allowedToSend']=!0x0,this[_0x2265d2(0x155)]=0x0,_0x1f2633))[_0x2265d2(0xe2)](_0x5bafe3=>(this[_0x2265d2(0x130)]=!0x1,this['_connecting']=!0x1,console['warn'](_0x2265d2(0x13c)+this[_0x2265d2(0x16e)]),_0x1aba26(new Error(_0x2265d2(0x121)+(_0x5bafe3&&_0x5bafe3[_0x2265d2(0x1b0)])))));}));},z['prototype'][_0x3bccce(0xd5)]=function(_0x20904a){var _0x2e26a8=_0x3bccce;this[_0x2e26a8(0x130)]=!0x1,this[_0x2e26a8(0x174)]=!0x1;try{_0x20904a[_0x2e26a8(0xea)]=null,_0x20904a[_0x2e26a8(0xb7)]=null,_0x20904a['onopen']=null;}catch{}try{_0x20904a[_0x2e26a8(0x19b)]<0x2&&_0x20904a[_0x2e26a8(0xf5)]();}catch{}},z['prototype'][_0x3bccce(0x1c2)]=function(){var _0x120c79=_0x3bccce;clearTimeout(this[_0x120c79(0x17a)]),!(this[_0x120c79(0x155)]>=this[_0x120c79(0xc2)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x374d9c=_0x120c79,_0x2c033a;this[_0x374d9c(0x130)]||this['_connecting']||(this[_0x374d9c(0x1a8)](),(_0x2c033a=this[_0x374d9c(0x12e)])==null||_0x2c033a[_0x374d9c(0xe2)](()=>this['_attemptToReconnectShortly']()));},0x1f4),this[_0x120c79(0x17a)]['unref']&&this['_reconnectTimeout'][_0x120c79(0x1ae)]());},z[_0x3bccce(0x146)][_0x3bccce(0xb8)]=async function(_0x22c768){var _0x51e33a=_0x3bccce;try{if(!this[_0x51e33a(0x17e)])return;this['_allowedToConnectOnSend']&&this[_0x51e33a(0x1a8)](),(await this[_0x51e33a(0x12e)])['send'](JSON[_0x51e33a(0xbd)](_0x22c768));}catch(_0x5260c8){this[_0x51e33a(0x170)]?console[_0x51e33a(0xbc)](this[_0x51e33a(0x1a7)]+':\\x20'+(_0x5260c8&&_0x5260c8['message'])):(this[_0x51e33a(0x170)]=!0x0,console[_0x51e33a(0xbc)](this[_0x51e33a(0x1a7)]+':\\x20'+(_0x5260c8&&_0x5260c8[_0x51e33a(0x1b0)]),_0x22c768)),this[_0x51e33a(0x17e)]=!0x1,this[_0x51e33a(0x1c2)]();}};function _0x5e98(){var _0x3c1a84=['now','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','10.0.2.2','data','console','concat','_hasSymbolPropertyOnItsPath','_disposeWebsocket','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)','null','resetWhenQuietMs','react-native','resolve','test','_inBrowser','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','hostname','fromCharCode','_consoleNinjaAllowedToStart','number','catch','bound\\x20Promise','_inNextEdge','parent','timeStamp','undefined','parse','reduceOnAccumulatedProcessingTimeMs','onclose','_undefined','_socket','remix','edge','name','node','_getOwnPropertySymbols','astro','host','then','close','angular','Number','positiveInfinity','log','Set','_console_ninja','','_isMap','getOwnPropertySymbols','perf_hooks','join','constructor','_objectToString','ninjaSuppressConsole','slice','index','5700192QCRPnQ','match','type','versions','[object\\x20Map]','10SYTKRC','trace','_setNodeQueryPath','resetOnProcessingTimeAverageMs','_addFunctionsNode','props','_numberRegExp','isArray','_getOwnPropertyNames','origin','_p_','elements','autoExpand','55345','negativeInfinity','cappedElements','nodeModules','ws://','[object\\x20Set]','reducePolicy',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"10.0.2.2\",\"DESKTOP-NJA3QVG\",\"10.0.10.209\"],'nan','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','209580XQJBhV','boolean','setter','_hasSetOnItsPath','Map','_WebSocket','sortProps','startsWith','object','push','_setNodeExpressionPath','_console_ninja_session','_ws','valueOf','_connected','emulator','root_exp','modules','getWebSocketClass','disabledTrace','_additionalMetadata','_processTreeNodeResult','_addObjectProperty','_addLoadNode','1016268sxaONp','elapsed','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','replace','Error','toUpperCase','serialize','222005KTsWxj','\\x20browser','1.0.0','capped','_isPrimitiveType','prototype','some','autoExpandMaxDepth','toLowerCase','Promise','totalStrLength','symbol',\"c:\\\\Users\\\\mhmda\\\\.antigravity-ide\\\\extensions\\\\wallabyjs.console-ninja-1.0.528-universal\\\\node_modules\",'onmessage','_isPrimitiveWrapperType','time','android','_isSet','map',',\\x20see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','_connectAttemptCount','bigint','_cleanNode','_sortProps','dockerizedApp','allStrLength','performance','_ninjaIgnoreNextError','current','length','_p_length','perLogpoint','process','_propertyName','bind','resolveGetters','port','webpack','[object\\x20Array]','21dutNaI','\\x20server','import(\\x27path\\x27)','HTMLAllCollection','get','autoExpandPropertyCount','_webSocketErrorDocsLink','_type','_extendedWarning','root_exp_id','reduceOnCount','strLength','_connecting','getOwnPropertyNames','getOwnPropertyDescriptor','gateway.docker.internal','count','return\\x20import(url.pathToFileURL(path.join(nodeModules,\\x20\\x27ws/index.js\\x27)).toString());','_reconnectTimeout','[object\\x20Date]','stack','unknown','_allowedToSend','37PXcKeV','_getOwnPropertyDescriptor','array','indexOf','noFunctions','getter','path','args','_keyStrRegExp','logger\\x20websocket\\x20error','_addProperty','value','NEGATIVE_INFINITY','_WebSocketClass','_isArray','default','686PkUofF','expo','_treeNodePropertiesBeforeFullValue','autoExpandPreviousObjects','_HTMLAllCollection','reducedLimits','_treeNodePropertiesAfterFullValue','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','cappedProps','disabledLog','hits','method','readyState','env','_isNegativeZero','ExpoDevice','POSITIVE_INFINITY','reduceLimits','expressionsToEvaluate','unshift','string','funcName','toString','autoExpandLimit','_sendErrorMessage','_connectToHostNow','hasOwnProperty','function','call','String','1288kqqczz','unref','isExpressionToEvaluate','message','negativeZero','_Symbol',{\"resolveGetters\":false,\"defaultLimits\":{\"props\":100,\"elements\":100,\"strLength\":51200,\"totalStrLength\":51200,\"autoExpandLimit\":5000,\"autoExpandMaxDepth\":10},\"reducedLimits\":{\"props\":5,\"elements\":5,\"strLength\":256,\"totalStrLength\":768,\"autoExpandLimit\":30,\"autoExpandMaxDepth\":2},\"reducePolicy\":{\"perLogpoint\":{\"reduceOnCount\":50,\"reduceOnAccumulatedProcessingTimeMs\":100,\"resetWhenQuietMs\":500,\"resetOnProcessingTimeAverageMs\":100},\"global\":{\"reduceOnCount\":1000,\"reduceOnAccumulatedProcessingTimeMs\":300,\"resetWhenQuietMs\":50,\"resetOnProcessingTimeAverageMs\":100}}},'[object\\x20BigInt]','_dateToString','_setNodeLabel','level','next.js','depth','eventReceivedCallback','error','includes','_blacklistedProperty','stackTraceLimit','date','_allowedToConnectOnSend','iterator','_attemptToReconnectShortly','...','_isUndefined','url','hrtime','Buffer','264ieXPUE','onerror','send','charAt','Boolean','46652kCJfEm','warn','stringify','defaultLimits','127.0.0.1','coverage','RegExp','_maxConnectAttemptCount','location','_setNodeId','_setNodePermissions','WebSocket','NEXT_RUNTIME','forEach','8906967csHRqh','_property','substr','global','_regExpToString'];_0x5e98=function(){return _0x3c1a84;};return _0x5e98();}function _0x3f31(_0x87199c,_0x5d8a33){var _0x5e98d6=_0x5e98();return _0x3f31=function(_0x3f31ad,_0x358784){_0x3f31ad=_0x3f31ad-0xb5;var _0x36bfb3=_0x5e98d6[_0x3f31ad];return _0x36bfb3;},_0x3f31(_0x87199c,_0x5d8a33);}function H(_0x366540,_0x1ad816,_0x529823,_0x2cd57a,_0x57c670,_0x2877db,_0x42454c,_0x5d3dc4=ne){var _0x13ef61=_0x3bccce;let _0x186b3d=_0x529823['split'](',')[_0x13ef61(0x153)](_0x115c45=>{var _0x4f73cf=_0x13ef61,_0x38a131,_0x59c12e,_0x417e95,_0x4e5840,_0x38edbd,_0x2a14ec,_0x36ea69,_0x5adcee;try{if(!_0x366540[_0x4f73cf(0x12d)]){let _0x3a90f3=((_0x59c12e=(_0x38a131=_0x366540[_0x4f73cf(0x161)])==null?void 0x0:_0x38a131[_0x4f73cf(0x109)])==null?void 0x0:_0x59c12e[_0x4f73cf(0xf0)])||((_0x4e5840=(_0x417e95=_0x366540[_0x4f73cf(0x161)])==null?void 0x0:_0x417e95[_0x4f73cf(0x19c)])==null?void 0x0:_0x4e5840['NEXT_RUNTIME'])==='edge';(_0x57c670===_0x4f73cf(0x1b8)||_0x57c670===_0x4f73cf(0xed)||_0x57c670===_0x4f73cf(0xf2)||_0x57c670===_0x4f73cf(0xf6))&&(_0x57c670+=_0x3a90f3?_0x4f73cf(0x169):_0x4f73cf(0x142));let _0x14780d='';_0x57c670===_0x4f73cf(0xd9)&&(_0x14780d=(((_0x36ea69=(_0x2a14ec=(_0x38edbd=_0x366540[_0x4f73cf(0x190)])==null?void 0x0:_0x38edbd['modules'])==null?void 0x0:_0x2a14ec[_0x4f73cf(0x19e)])==null?void 0x0:_0x36ea69['osName'])||'emulator')[_0x4f73cf(0x149)](),_0x14780d&&(_0x57c670+='\\x20'+_0x14780d,(_0x14780d===_0x4f73cf(0x151)||_0x14780d===_0x4f73cf(0x131)&&((_0x5adcee=_0x366540['location'])==null?void 0x0:_0x5adcee[_0x4f73cf(0xde)])===_0x4f73cf(0xd0))&&(_0x1ad816=_0x4f73cf(0xd0)))),_0x366540[_0x4f73cf(0x12d)]={'id':+new Date(),'tool':_0x57c670},_0x42454c&&_0x57c670&&!_0x3a90f3&&(_0x14780d?console[_0x4f73cf(0xf9)]('Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20'+_0x14780d+_0x4f73cf(0x154)):console['log']('%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20'+(_0x57c670[_0x4f73cf(0xb9)](0x0)[_0x4f73cf(0x13f)]()+_0x57c670[_0x4f73cf(0xcb)](0x1))+',',_0x4f73cf(0xd6),_0x4f73cf(0xdd)));}let _0x51969a=new z(_0x366540,_0x1ad816,_0x115c45,_0x2cd57a,_0x2877db,_0x5d3dc4);return _0x51969a[_0x4f73cf(0xb8)][_0x4f73cf(0x163)](_0x51969a);}catch(_0x16c9cf){return console['warn']('logger\\x20failed\\x20to\\x20connect\\x20to\\x20host',_0x16c9cf&&_0x16c9cf[_0x4f73cf(0x1b0)]),()=>{};}});return _0x2d0a9b=>_0x186b3d[_0x13ef61(0xc8)](_0x39c874=>_0x39c874(_0x2d0a9b));}function ne(_0x3070f6,_0x32371d,_0x287e65,_0x4dc2bc){_0x4dc2bc&&_0x3070f6==='reload'&&_0x287e65['location']['reload']();}function b(_0x2c46f3){var _0x3fb916=_0x3bccce,_0x36fdf0,_0xf5f639;let _0x3a2230=function(_0x36c956,_0x559d27){return _0x559d27-_0x36c956;},_0x30376f;if(_0x2c46f3[_0x3fb916(0x15b)])_0x30376f=function(){var _0x5cc7dc=_0x3fb916;return _0x2c46f3[_0x5cc7dc(0x15b)][_0x5cc7dc(0xce)]();};else{if(_0x2c46f3[_0x3fb916(0x161)]&&_0x2c46f3[_0x3fb916(0x161)][_0x3fb916(0x1c6)]&&((_0xf5f639=(_0x36fdf0=_0x2c46f3[_0x3fb916(0x161)])==null?void 0x0:_0x36fdf0[_0x3fb916(0x19c)])==null?void 0x0:_0xf5f639[_0x3fb916(0xc7)])!==_0x3fb916(0xee))_0x30376f=function(){return _0x2c46f3['process']['hrtime']();},_0x3a2230=function(_0x4325b1,_0xb89673){return 0x3e8*(_0xb89673[0x0]-_0x4325b1[0x0])+(_0xb89673[0x1]-_0x4325b1[0x1])/0xf4240;};else try{let {performance:_0x3d3014}=require(_0x3fb916(0xff));_0x30376f=function(){return _0x3d3014['now']();};}catch{_0x30376f=function(){return+new Date();};}}return{'elapsed':_0x3a2230,'timeStamp':_0x30376f,'now':()=>Date['now']()};}function X(_0x59d7d9,_0x563c9a,_0xc9c262){var _0x3ecb33=_0x3bccce,_0x389b48,_0x362b75,_0x5add1b,_0x133dcf,_0x54b544,_0x49acd7,_0x2e6435;if(_0x59d7d9[_0x3ecb33(0xe0)]!==void 0x0)return _0x59d7d9[_0x3ecb33(0xe0)];let _0x59b293=((_0x362b75=(_0x389b48=_0x59d7d9[_0x3ecb33(0x161)])==null?void 0x0:_0x389b48[_0x3ecb33(0x109)])==null?void 0x0:_0x362b75['node'])||((_0x133dcf=(_0x5add1b=_0x59d7d9['process'])==null?void 0x0:_0x5add1b[_0x3ecb33(0x19c)])==null?void 0x0:_0x133dcf[_0x3ecb33(0xc7)])===_0x3ecb33(0xee),_0x4960cb=!!(_0xc9c262===_0x3ecb33(0xd9)&&((_0x54b544=_0x59d7d9[_0x3ecb33(0x190)])==null?void 0x0:_0x54b544[_0x3ecb33(0x133)]));function _0x2499ae(_0x2069c1){var _0x4b89b3=_0x3ecb33;if(_0x2069c1[_0x4b89b3(0x129)]('/')&&_0x2069c1['endsWith']('/')){let _0x4213bf=new RegExp(_0x2069c1[_0x4b89b3(0x104)](0x1,-0x1));return _0x4407d0=>_0x4213bf[_0x4b89b3(0xdb)](_0x4407d0);}else{if(_0x2069c1[_0x4b89b3(0x1bc)]('*')||_0x2069c1[_0x4b89b3(0x1bc)]('?')){let _0x1c99b3=new RegExp('^'+_0x2069c1[_0x4b89b3(0x13d)](/\\./g,String[_0x4b89b3(0xdf)](0x5c)+'.')[_0x4b89b3(0x13d)](/\\*/g,'.*')[_0x4b89b3(0x13d)](/\\?/g,'.')+String[_0x4b89b3(0xdf)](0x24));return _0x71cca3=>_0x1c99b3['test'](_0x71cca3);}else return _0x136229=>_0x136229===_0x2069c1;}}let _0x2694fe=_0x563c9a['map'](_0x2499ae);return _0x59d7d9['_consoleNinjaAllowedToStart']=_0x59b293||!_0x563c9a,!_0x59d7d9[_0x3ecb33(0xe0)]&&((_0x49acd7=_0x59d7d9[_0x3ecb33(0xc3)])==null?void 0x0:_0x49acd7[_0x3ecb33(0xde)])&&(_0x59d7d9['_consoleNinjaAllowedToStart']=_0x2694fe[_0x3ecb33(0x147)](_0x40a30a=>_0x40a30a(_0x59d7d9['location']['hostname']))),_0x4960cb&&!_0x59d7d9[_0x3ecb33(0xe0)]&&!((_0x2e6435=_0x59d7d9['location'])!=null&&_0x2e6435['hostname'])&&(_0x59d7d9[_0x3ecb33(0xe0)]=!0x0),_0x59d7d9[_0x3ecb33(0xe0)];}function J(_0x2ef3dc,_0x374cb9,_0x2adc0c,_0x48da5d,_0x2d63c0,_0x3b6fce){var _0xf1105=_0x3bccce;_0x2ef3dc=_0x2ef3dc,_0x374cb9=_0x374cb9,_0x2adc0c=_0x2adc0c,_0x48da5d=_0x48da5d,_0x2d63c0=_0x2d63c0,_0x2d63c0=_0x2d63c0||{},_0x2d63c0[_0xf1105(0xbe)]=_0x2d63c0[_0xf1105(0xbe)]||{},_0x2d63c0[_0xf1105(0x194)]=_0x2d63c0['reducedLimits']||{},_0x2d63c0['reducePolicy']=_0x2d63c0[_0xf1105(0x11e)]||{},_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)]=_0x2d63c0[_0xf1105(0x11e)]['perLogpoint']||{},_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)]=_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)]||{};let _0x184542={'perLogpoint':{'reduceOnCount':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)][_0xf1105(0x172)]||0x32,'reduceOnAccumulatedProcessingTimeMs':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)][_0xf1105(0xe9)]||0x64,'resetWhenQuietMs':_0x2d63c0['reducePolicy'][_0xf1105(0x160)][_0xf1105(0xd8)]||0x1f4,'resetOnProcessingTimeAverageMs':_0x2d63c0[_0xf1105(0x11e)]['perLogpoint'][_0xf1105(0x10e)]||0x64},'global':{'reduceOnCount':_0x2d63c0['reducePolicy']['global'][_0xf1105(0x172)]||0x3e8,'reduceOnAccumulatedProcessingTimeMs':_0x2d63c0['reducePolicy'][_0xf1105(0xcc)][_0xf1105(0xe9)]||0x12c,'resetWhenQuietMs':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)][_0xf1105(0xd8)]||0x32,'resetOnProcessingTimeAverageMs':_0x2d63c0[_0xf1105(0x11e)]['global'][_0xf1105(0x10e)]||0x64}},_0x4daa0c=b(_0x2ef3dc),_0x56adc0=_0x4daa0c[_0xf1105(0x13b)],_0x27a290=_0x4daa0c[_0xf1105(0xe6)];function _0x4b6695(){var _0x5e8eee=_0xf1105;this[_0x5e8eee(0x187)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x5e8eee(0x111)]=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this[_0x5e8eee(0xeb)]=_0x2ef3dc[_0x5e8eee(0xe7)],this[_0x5e8eee(0x193)]=_0x2ef3dc[_0x5e8eee(0x16b)],this['_getOwnPropertyDescriptor']=Object[_0x5e8eee(0x176)],this[_0x5e8eee(0x113)]=Object[_0x5e8eee(0x175)],this[_0x5e8eee(0x1b2)]=_0x2ef3dc['Symbol'],this[_0x5e8eee(0xcd)]=RegExp[_0x5e8eee(0x146)][_0x5e8eee(0x1a5)],this[_0x5e8eee(0x1b5)]=Date[_0x5e8eee(0x146)][_0x5e8eee(0x1a5)];}_0x4b6695['prototype'][_0xf1105(0x140)]=function(_0x3261e7,_0x2a85a5,_0x3cae09,_0x3665c0){var _0x1b56af=_0xf1105,_0x480b53=this,_0x318937=_0x3cae09[_0x1b56af(0x117)];function _0x3c86d9(_0x3a7ae5,_0x2f6d30,_0x51459e){var _0x4403e2=_0x1b56af;_0x2f6d30[_0x4403e2(0x108)]='unknown',_0x2f6d30[_0x4403e2(0x1bb)]=_0x3a7ae5['message'],_0x48ae90=_0x51459e[_0x4403e2(0xf0)][_0x4403e2(0x15d)],_0x51459e[_0x4403e2(0xf0)]['current']=_0x2f6d30,_0x480b53[_0x4403e2(0x191)](_0x2f6d30,_0x51459e);}let _0x4d5312,_0x366e19,_0x4e293d=_0x2ef3dc['ninjaSuppressConsole'];_0x2ef3dc[_0x1b56af(0x103)]=!0x0,_0x2ef3dc[_0x1b56af(0xd2)]&&(_0x4d5312=_0x2ef3dc['console'][_0x1b56af(0x1bb)],_0x366e19=_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0xbc)],_0x4d5312&&(_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0x1bb)]=function(){}),_0x366e19&&(_0x2ef3dc[_0x1b56af(0xd2)]['warn']=function(){}));try{try{_0x3cae09['level']++,_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09[_0x1b56af(0x192)][_0x1b56af(0x12b)](_0x2a85a5);var _0x2b9bff,_0x365e06,_0x51eada,_0x2f7f6b,_0x395c4d=[],_0x2430fe=[],_0x31200e,_0x21f5bd=this[_0x1b56af(0x16f)](_0x2a85a5),_0x1de47f=_0x21f5bd===_0x1b56af(0x181),_0x6d9a23=!0x1,_0x4d80ed=_0x21f5bd===_0x1b56af(0x1aa),_0x221405=this[_0x1b56af(0x145)](_0x21f5bd),_0x142872=this[_0x1b56af(0x14f)](_0x21f5bd),_0x53c606=_0x221405||_0x142872,_0x3928e5={},_0x5f3923=0x0,_0x1a3a29=!0x1,_0x48ae90,_0x4ef1ce=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x3cae09['depth']){if(_0x1de47f){if(_0x365e06=_0x2a85a5['length'],_0x365e06>_0x3cae09[_0x1b56af(0x116)]){for(_0x51eada=0x0,_0x2f7f6b=_0x3cae09[_0x1b56af(0x116)],_0x2b9bff=_0x51eada;_0x2b9bff<_0x2f7f6b;_0x2b9bff++)_0x2430fe[_0x1b56af(0x12b)](_0x480b53[_0x1b56af(0x189)](_0x395c4d,_0x2a85a5,_0x21f5bd,_0x2b9bff,_0x3cae09));_0x3261e7[_0x1b56af(0x11a)]=!0x0;}else{for(_0x51eada=0x0,_0x2f7f6b=_0x365e06,_0x2b9bff=_0x51eada;_0x2b9bff<_0x2f7f6b;_0x2b9bff++)_0x2430fe[_0x1b56af(0x12b)](_0x480b53[_0x1b56af(0x189)](_0x395c4d,_0x2a85a5,_0x21f5bd,_0x2b9bff,_0x3cae09));}_0x3cae09[_0x1b56af(0x16d)]+=_0x2430fe[_0x1b56af(0x15e)];}if(!(_0x21f5bd===_0x1b56af(0xd7)||_0x21f5bd===_0x1b56af(0xe7))&&!_0x221405&&_0x21f5bd!=='String'&&_0x21f5bd!==_0x1b56af(0xb5)&&_0x21f5bd!==_0x1b56af(0x156)){var _0x42574d=_0x3665c0[_0x1b56af(0x110)]||_0x3cae09[_0x1b56af(0x110)];if(this[_0x1b56af(0x152)](_0x2a85a5)?(_0x2b9bff=0x0,_0x2a85a5[_0x1b56af(0xc8)](function(_0x1fe9c2){var _0x34f0dd=_0x1b56af;if(_0x5f3923++,_0x3cae09[_0x34f0dd(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;return;}if(!_0x3cae09[_0x34f0dd(0x1af)]&&_0x3cae09[_0x34f0dd(0x117)]&&_0x3cae09[_0x34f0dd(0x16d)]>_0x3cae09[_0x34f0dd(0x1a6)]){_0x1a3a29=!0x0;return;}_0x2430fe['push'](_0x480b53['_addProperty'](_0x395c4d,_0x2a85a5,_0x34f0dd(0xfa),_0x2b9bff++,_0x3cae09,function(_0x1073eb){return function(){return _0x1073eb;};}(_0x1fe9c2)));})):this[_0x1b56af(0xfd)](_0x2a85a5)&&_0x2a85a5['forEach'](function(_0x9aea6,_0x3dacb6){var _0x57160a=_0x1b56af;if(_0x5f3923++,_0x3cae09[_0x57160a(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;return;}if(!_0x3cae09[_0x57160a(0x1af)]&&_0x3cae09[_0x57160a(0x117)]&&_0x3cae09[_0x57160a(0x16d)]>_0x3cae09[_0x57160a(0x1a6)]){_0x1a3a29=!0x0;return;}var _0x443b52=_0x3dacb6[_0x57160a(0x1a5)]();_0x443b52[_0x57160a(0x15e)]>0x64&&(_0x443b52=_0x443b52[_0x57160a(0x104)](0x0,0x64)+_0x57160a(0x1c3)),_0x2430fe[_0x57160a(0x12b)](_0x480b53[_0x57160a(0x189)](_0x395c4d,_0x2a85a5,'Map',_0x443b52,_0x3cae09,function(_0x1c464c){return function(){return _0x1c464c;};}(_0x9aea6)));}),!_0x6d9a23){try{for(_0x31200e in _0x2a85a5)if(!(_0x1de47f&&_0x4ef1ce[_0x1b56af(0xdb)](_0x31200e))&&!this[_0x1b56af(0x1bd)](_0x2a85a5,_0x31200e,_0x3cae09)){if(_0x5f3923++,_0x3cae09[_0x1b56af(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;break;}if(!_0x3cae09[_0x1b56af(0x1af)]&&_0x3cae09['autoExpand']&&_0x3cae09[_0x1b56af(0x16d)]>_0x3cae09[_0x1b56af(0x1a6)]){_0x1a3a29=!0x0;break;}_0x2430fe['push'](_0x480b53[_0x1b56af(0x138)](_0x395c4d,_0x3928e5,_0x2a85a5,_0x21f5bd,_0x31200e,_0x3cae09));}}catch{}if(_0x3928e5[_0x1b56af(0x15f)]=!0x0,_0x4d80ed&&(_0x3928e5['_p_name']=!0x0),!_0x1a3a29){var _0x281cac=[][_0x1b56af(0xd3)](this[_0x1b56af(0x113)](_0x2a85a5))[_0x1b56af(0xd3)](this[_0x1b56af(0xf1)](_0x2a85a5));for(_0x2b9bff=0x0,_0x365e06=_0x281cac[_0x1b56af(0x15e)];_0x2b9bff<_0x365e06;_0x2b9bff++)if(_0x31200e=_0x281cac[_0x2b9bff],!(_0x1de47f&&_0x4ef1ce[_0x1b56af(0xdb)](_0x31200e[_0x1b56af(0x1a5)]()))&&!this[_0x1b56af(0x1bd)](_0x2a85a5,_0x31200e,_0x3cae09)&&!_0x3928e5[typeof _0x31200e!=_0x1b56af(0x14c)?_0x1b56af(0x115)+_0x31200e['toString']():_0x31200e]){if(_0x5f3923++,_0x3cae09[_0x1b56af(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;break;}if(!_0x3cae09[_0x1b56af(0x1af)]&&_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09[_0x1b56af(0x16d)]>_0x3cae09[_0x1b56af(0x1a6)]){_0x1a3a29=!0x0;break;}_0x2430fe['push'](_0x480b53['_addObjectProperty'](_0x395c4d,_0x3928e5,_0x2a85a5,_0x21f5bd,_0x31200e,_0x3cae09));}}}}}if(_0x3261e7['type']=_0x21f5bd,_0x53c606?(_0x3261e7[_0x1b56af(0x18a)]=_0x2a85a5[_0x1b56af(0x12f)](),this['_capIfString'](_0x21f5bd,_0x3261e7,_0x3cae09,_0x3665c0)):_0x21f5bd===_0x1b56af(0x1bf)?_0x3261e7[_0x1b56af(0x18a)]=this['_dateToString'][_0x1b56af(0x1ab)](_0x2a85a5):_0x21f5bd===_0x1b56af(0x156)?_0x3261e7['value']=_0x2a85a5[_0x1b56af(0x1a5)]():_0x21f5bd===_0x1b56af(0xc1)?_0x3261e7[_0x1b56af(0x18a)]=this[_0x1b56af(0xcd)][_0x1b56af(0x1ab)](_0x2a85a5):_0x21f5bd===_0x1b56af(0x14c)&&this['_Symbol']?_0x3261e7[_0x1b56af(0x18a)]=this[_0x1b56af(0x1b2)]['prototype'][_0x1b56af(0x1a5)][_0x1b56af(0x1ab)](_0x2a85a5):!_0x3cae09[_0x1b56af(0x1b9)]&&!(_0x21f5bd===_0x1b56af(0xd7)||_0x21f5bd===_0x1b56af(0xe7))&&(delete _0x3261e7['value'],_0x3261e7[_0x1b56af(0x144)]=!0x0),_0x1a3a29&&(_0x3261e7[_0x1b56af(0x197)]=!0x0),_0x48ae90=_0x3cae09['node'][_0x1b56af(0x15d)],_0x3cae09[_0x1b56af(0xf0)]['current']=_0x3261e7,this[_0x1b56af(0x191)](_0x3261e7,_0x3cae09),_0x2430fe['length']){for(_0x2b9bff=0x0,_0x365e06=_0x2430fe['length'];_0x2b9bff<_0x365e06;_0x2b9bff++)_0x2430fe[_0x2b9bff](_0x2b9bff);}_0x395c4d['length']&&(_0x3261e7['props']=_0x395c4d);}catch(_0x31e085){_0x3c86d9(_0x31e085,_0x3261e7,_0x3cae09);}this[_0x1b56af(0x136)](_0x2a85a5,_0x3261e7),this[_0x1b56af(0x195)](_0x3261e7,_0x3cae09),_0x3cae09[_0x1b56af(0xf0)][_0x1b56af(0x15d)]=_0x48ae90,_0x3cae09[_0x1b56af(0x1b7)]--,_0x3cae09[_0x1b56af(0x117)]=_0x318937,_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09['autoExpandPreviousObjects']['pop']();}finally{_0x4d5312&&(_0x2ef3dc['console'][_0x1b56af(0x1bb)]=_0x4d5312),_0x366e19&&(_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0xbc)]=_0x366e19),_0x2ef3dc[_0x1b56af(0x103)]=_0x4e293d;}return _0x3261e7;},_0x4b6695['prototype'][_0xf1105(0xf1)]=function(_0x2dffd5){var _0x36e625=_0xf1105;return Object['getOwnPropertySymbols']?Object[_0x36e625(0xfe)](_0x2dffd5):[];},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x152)]=function(_0x38b8f3){var _0x1dc055=_0xf1105;return!!(_0x38b8f3&&_0x2ef3dc['Set']&&this[_0x1dc055(0x102)](_0x38b8f3)===_0x1dc055(0x11d)&&_0x38b8f3[_0x1dc055(0xc8)]);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1bd)]=function(_0x2e1402,_0x599573,_0x327e2a){var _0x266432=_0xf1105;if(!_0x327e2a[_0x266432(0x164)]){let _0x4a8695=this[_0x266432(0x180)](_0x2e1402,_0x599573);if(_0x4a8695&&_0x4a8695[_0x266432(0x16c)])return!0x0;}return _0x327e2a['noFunctions']?typeof _0x2e1402[_0x599573]==_0x266432(0x1aa):!0x1;},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x16f)]=function(_0x17d3cd){var _0x33bb02=_0xf1105,_0x51eeb7='';return _0x51eeb7=typeof _0x17d3cd,_0x51eeb7==='object'?this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x167)?_0x51eeb7='array':this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x17b)?_0x51eeb7=_0x33bb02(0x1bf):this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x1b4)?_0x51eeb7='bigint':_0x17d3cd===null?_0x51eeb7='null':_0x17d3cd[_0x33bb02(0x101)]&&(_0x51eeb7=_0x17d3cd[_0x33bb02(0x101)]['name']||_0x51eeb7):_0x51eeb7===_0x33bb02(0xe7)&&this['_HTMLAllCollection']&&_0x17d3cd instanceof this[_0x33bb02(0x193)]&&(_0x51eeb7=_0x33bb02(0x16b)),_0x51eeb7;},_0x4b6695['prototype'][_0xf1105(0x102)]=function(_0x599a50){var _0x1c1569=_0xf1105;return Object[_0x1c1569(0x146)][_0x1c1569(0x1a5)]['call'](_0x599a50);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x145)]=function(_0x981ad6){var _0x3765e0=_0xf1105;return _0x981ad6===_0x3765e0(0x123)||_0x981ad6==='string'||_0x981ad6==='number';},_0x4b6695[_0xf1105(0x146)]['_isPrimitiveWrapperType']=function(_0x587693){var _0x56b72b=_0xf1105;return _0x587693===_0x56b72b(0xba)||_0x587693==='String'||_0x587693===_0x56b72b(0xf7);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x189)]=function(_0x5315b6,_0x963e84,_0x1d7c45,_0x2640dd,_0x429168,_0x476f09){var _0x593df4=this;return function(_0x10cfd6){var _0x59774c=_0x3f31,_0x557bef=_0x429168[_0x59774c(0xf0)]['current'],_0x402196=_0x429168[_0x59774c(0xf0)]['index'],_0x4d62aa=_0x429168[_0x59774c(0xf0)][_0x59774c(0xe5)];_0x429168[_0x59774c(0xf0)][_0x59774c(0xe5)]=_0x557bef,_0x429168[_0x59774c(0xf0)][_0x59774c(0x105)]=typeof _0x2640dd==_0x59774c(0xe1)?_0x2640dd:_0x10cfd6,_0x5315b6['push'](_0x593df4[_0x59774c(0xca)](_0x963e84,_0x1d7c45,_0x2640dd,_0x429168,_0x476f09)),_0x429168['node'][_0x59774c(0xe5)]=_0x4d62aa,_0x429168['node'][_0x59774c(0x105)]=_0x402196;};},_0x4b6695[_0xf1105(0x146)]['_addObjectProperty']=function(_0x4a7321,_0x51f979,_0x4c6bab,_0x5d94c7,_0x27c326,_0x597901,_0x34f06d){var _0x2a8b1a=_0xf1105,_0x2652ab=this;return _0x51f979[typeof _0x27c326!=_0x2a8b1a(0x14c)?'_p_'+_0x27c326[_0x2a8b1a(0x1a5)]():_0x27c326]=!0x0,function(_0x3b6cce){var _0x26f7b0=_0x2a8b1a,_0x357f84=_0x597901['node'][_0x26f7b0(0x15d)],_0x16e668=_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)],_0x2b6940=_0x597901['node'][_0x26f7b0(0xe5)];_0x597901['node'][_0x26f7b0(0xe5)]=_0x357f84,_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)]=_0x3b6cce,_0x4a7321[_0x26f7b0(0x12b)](_0x2652ab[_0x26f7b0(0xca)](_0x4c6bab,_0x5d94c7,_0x27c326,_0x597901,_0x34f06d)),_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0xe5)]=_0x2b6940,_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)]=_0x16e668;};},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xca)]=function(_0x5a4ee8,_0x46576b,_0x4a16f5,_0x363bf8,_0x5691f8){var _0x3dbbb9=_0xf1105,_0x1dae2c=this;_0x5691f8||(_0x5691f8=function(_0x407398,_0x12cce1){return _0x407398[_0x12cce1];});var _0x1775e5=_0x4a16f5[_0x3dbbb9(0x1a5)](),_0x5a1af9=_0x363bf8['expressionsToEvaluate']||{},_0x538d1f=_0x363bf8[_0x3dbbb9(0x1b9)],_0xeadf82=_0x363bf8[_0x3dbbb9(0x1af)];try{var _0x239d4c=this['_isMap'](_0x5a4ee8),_0x3fa586=_0x1775e5;_0x239d4c&&_0x3fa586[0x0]==='\\x27'&&(_0x3fa586=_0x3fa586[_0x3dbbb9(0xcb)](0x1,_0x3fa586[_0x3dbbb9(0x15e)]-0x2));var _0x4d3d53=_0x363bf8[_0x3dbbb9(0x1a1)]=_0x5a1af9[_0x3dbbb9(0x115)+_0x3fa586];_0x4d3d53&&(_0x363bf8[_0x3dbbb9(0x1b9)]=_0x363bf8[_0x3dbbb9(0x1b9)]+0x1),_0x363bf8['isExpressionToEvaluate']=!!_0x4d3d53;var _0x1e90e1=typeof _0x4a16f5==_0x3dbbb9(0x14c),_0x5557fc={'name':_0x1e90e1||_0x239d4c?_0x1775e5:this[_0x3dbbb9(0x162)](_0x1775e5)};if(_0x1e90e1&&(_0x5557fc[_0x3dbbb9(0x14c)]=!0x0),!(_0x46576b===_0x3dbbb9(0x181)||_0x46576b===_0x3dbbb9(0x13e))){var _0x2322a4=this[_0x3dbbb9(0x180)](_0x5a4ee8,_0x4a16f5);if(_0x2322a4&&(_0x2322a4['set']&&(_0x5557fc[_0x3dbbb9(0x124)]=!0x0),_0x2322a4[_0x3dbbb9(0x16c)]&&!_0x4d3d53&&!_0x363bf8[_0x3dbbb9(0x164)]))return _0x5557fc[_0x3dbbb9(0x184)]=!0x0,this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8),_0x5557fc;}var _0x480f9e;try{_0x480f9e=_0x5691f8(_0x5a4ee8,_0x4a16f5);}catch(_0x669526){return _0x5557fc={'name':_0x1775e5,'type':_0x3dbbb9(0x17d),'error':_0x669526[_0x3dbbb9(0x1b0)]},this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8),_0x5557fc;}var _0x4afb8b=this[_0x3dbbb9(0x16f)](_0x480f9e),_0x125bef=this['_isPrimitiveType'](_0x4afb8b);if(_0x5557fc[_0x3dbbb9(0x108)]=_0x4afb8b,_0x125bef)this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8,_0x480f9e,function(){_0x5557fc['value']=_0x480f9e['valueOf'](),!_0x4d3d53&&_0x1dae2c['_capIfString'](_0x4afb8b,_0x5557fc,_0x363bf8,{});});else{var _0x26d191=_0x363bf8[_0x3dbbb9(0x117)]&&_0x363bf8[_0x3dbbb9(0x1b7)]<_0x363bf8['autoExpandMaxDepth']&&_0x363bf8[_0x3dbbb9(0x192)][_0x3dbbb9(0x182)](_0x480f9e)<0x0&&_0x4afb8b!==_0x3dbbb9(0x1aa)&&_0x363bf8[_0x3dbbb9(0x16d)]<_0x363bf8['autoExpandLimit'];_0x26d191||_0x363bf8[_0x3dbbb9(0x1b7)]<_0x538d1f||_0x4d3d53?this[_0x3dbbb9(0x140)](_0x5557fc,_0x480f9e,_0x363bf8,_0x4d3d53||{}):this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8,_0x480f9e,function(){var _0x33aa2d=_0x3dbbb9;_0x4afb8b===_0x33aa2d(0xd7)||_0x4afb8b==='undefined'||(delete _0x5557fc[_0x33aa2d(0x18a)],_0x5557fc['capped']=!0x0);});}return _0x5557fc;}finally{_0x363bf8[_0x3dbbb9(0x1a1)]=_0x5a1af9,_0x363bf8[_0x3dbbb9(0x1b9)]=_0x538d1f,_0x363bf8[_0x3dbbb9(0x1af)]=_0xeadf82;}},_0x4b6695[_0xf1105(0x146)]['_capIfString']=function(_0x2712b6,_0x5ecf0a,_0x5823db,_0x584ac9){var _0x295ac6=_0xf1105,_0x1f41d6=_0x584ac9[_0x295ac6(0x173)]||_0x5823db[_0x295ac6(0x173)];if((_0x2712b6===_0x295ac6(0x1a3)||_0x2712b6===_0x295ac6(0x1ac))&&_0x5ecf0a['value']){let _0x4c36ee=_0x5ecf0a[_0x295ac6(0x18a)]['length'];_0x5823db[_0x295ac6(0x15a)]+=_0x4c36ee,_0x5823db[_0x295ac6(0x15a)]>_0x5823db[_0x295ac6(0x14b)]?(_0x5ecf0a['capped']='',delete _0x5ecf0a[_0x295ac6(0x18a)]):_0x4c36ee>_0x1f41d6&&(_0x5ecf0a[_0x295ac6(0x144)]=_0x5ecf0a['value']['substr'](0x0,_0x1f41d6),delete _0x5ecf0a[_0x295ac6(0x18a)]);}},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xfd)]=function(_0x3c4107){var _0x3201a3=_0xf1105;return!!(_0x3c4107&&_0x2ef3dc[_0x3201a3(0x126)]&&this[_0x3201a3(0x102)](_0x3c4107)===_0x3201a3(0x10a)&&_0x3c4107['forEach']);},_0x4b6695[_0xf1105(0x146)]['_propertyName']=function(_0x4f24bf){var _0x28c62a=_0xf1105;if(_0x4f24bf[_0x28c62a(0x107)](/^\\d+$/))return _0x4f24bf;var _0x2ed853;try{_0x2ed853=JSON[_0x28c62a(0xbd)](''+_0x4f24bf);}catch{_0x2ed853='\\x22'+this[_0x28c62a(0x102)](_0x4f24bf)+'\\x22';}return _0x2ed853['match'](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x2ed853=_0x2ed853[_0x28c62a(0xcb)](0x1,_0x2ed853[_0x28c62a(0x15e)]-0x2):_0x2ed853=_0x2ed853[_0x28c62a(0x13d)](/'/g,'\\x5c\\x27')['replace'](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x2ed853;},_0x4b6695['prototype'][_0xf1105(0x137)]=function(_0x1d3d3a,_0x1021e5,_0x15f618,_0x4429f5){var _0x538813=_0xf1105;this[_0x538813(0x191)](_0x1d3d3a,_0x1021e5),_0x4429f5&&_0x4429f5(),this[_0x538813(0x136)](_0x15f618,_0x1d3d3a),this[_0x538813(0x195)](_0x1d3d3a,_0x1021e5);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x191)]=function(_0x4e9752,_0x45cd5c){var _0xdedfe4=_0xf1105;this['_setNodeId'](_0x4e9752,_0x45cd5c),this[_0xdedfe4(0x10d)](_0x4e9752,_0x45cd5c),this['_setNodeExpressionPath'](_0x4e9752,_0x45cd5c),this['_setNodePermissions'](_0x4e9752,_0x45cd5c);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xc4)]=function(_0x522053,_0x233fb7){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x10d)]=function(_0x3cd83a,_0x33e46b){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1b6)]=function(_0x1df63c,_0x4c9023){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1c4)]=function(_0x447c56){return _0x447c56===this['_undefined'];},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x195)]=function(_0x37008c,_0x582d37){var _0x6feac6=_0xf1105;this['_setNodeLabel'](_0x37008c,_0x582d37),this['_setNodeExpandableState'](_0x37008c),_0x582d37[_0x6feac6(0x128)]&&this[_0x6feac6(0x158)](_0x37008c),this[_0x6feac6(0x10f)](_0x37008c,_0x582d37),this[_0x6feac6(0x139)](_0x37008c,_0x582d37),this[_0x6feac6(0x157)](_0x37008c);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x136)]=function(_0x11d9f1,_0x18aa13){var _0x572668=_0xf1105;try{_0x11d9f1&&typeof _0x11d9f1['length']==_0x572668(0xe1)&&(_0x18aa13[_0x572668(0x15e)]=_0x11d9f1[_0x572668(0x15e)]);}catch{}if(_0x18aa13[_0x572668(0x108)]===_0x572668(0xe1)||_0x18aa13[_0x572668(0x108)]===_0x572668(0xf7)){if(isNaN(_0x18aa13[_0x572668(0x18a)]))_0x18aa13[_0x572668(0x120)]=!0x0,delete _0x18aa13[_0x572668(0x18a)];else switch(_0x18aa13[_0x572668(0x18a)]){case Number[_0x572668(0x19f)]:_0x18aa13[_0x572668(0xf8)]=!0x0,delete _0x18aa13['value'];break;case Number[_0x572668(0x18b)]:_0x18aa13[_0x572668(0x119)]=!0x0,delete _0x18aa13[_0x572668(0x18a)];break;case 0x0:this[_0x572668(0x19d)](_0x18aa13['value'])&&(_0x18aa13[_0x572668(0x1b1)]=!0x0);break;}}else _0x18aa13['type']===_0x572668(0x1aa)&&typeof _0x11d9f1['name']==_0x572668(0x1a3)&&_0x11d9f1[_0x572668(0xef)]&&_0x18aa13['name']&&_0x11d9f1['name']!==_0x18aa13[_0x572668(0xef)]&&(_0x18aa13[_0x572668(0x1a4)]=_0x11d9f1[_0x572668(0xef)]);},_0x4b6695['prototype'][_0xf1105(0x19d)]=function(_0x43322c){var _0xec3877=_0xf1105;return 0x1/_0x43322c===Number[_0xec3877(0x18b)];},_0x4b6695[_0xf1105(0x146)]['_sortProps']=function(_0x14e6e9){var _0x19519e=_0xf1105;!_0x14e6e9[_0x19519e(0x110)]||!_0x14e6e9[_0x19519e(0x110)][_0x19519e(0x15e)]||_0x14e6e9['type']===_0x19519e(0x181)||_0x14e6e9[_0x19519e(0x108)]==='Map'||_0x14e6e9[_0x19519e(0x108)]==='Set'||_0x14e6e9[_0x19519e(0x110)]['sort'](function(_0x7dcfd2,_0x156d16){var _0x588999=_0x19519e,_0x1d0be9=_0x7dcfd2[_0x588999(0xef)]['toLowerCase'](),_0x58196a=_0x156d16[_0x588999(0xef)][_0x588999(0x149)]();return _0x1d0be9<_0x58196a?-0x1:_0x1d0be9>_0x58196a?0x1:0x0;});},_0x4b6695['prototype'][_0xf1105(0x10f)]=function(_0x194763,_0x2be225){var _0x43b3d9=_0xf1105;if(!(_0x2be225[_0x43b3d9(0x183)]||!_0x194763[_0x43b3d9(0x110)]||!_0x194763[_0x43b3d9(0x110)][_0x43b3d9(0x15e)])){for(var _0x275593=[],_0x302734=[],_0x2c0053=0x0,_0x156b23=_0x194763['props']['length'];_0x2c0053<_0x156b23;_0x2c0053++){var _0x29bc21=_0x194763[_0x43b3d9(0x110)][_0x2c0053];_0x29bc21[_0x43b3d9(0x108)]===_0x43b3d9(0x1aa)?_0x275593[_0x43b3d9(0x12b)](_0x29bc21):_0x302734[_0x43b3d9(0x12b)](_0x29bc21);}if(!(!_0x302734[_0x43b3d9(0x15e)]||_0x275593[_0x43b3d9(0x15e)]<=0x1)){_0x194763[_0x43b3d9(0x110)]=_0x302734;var _0x10b4f4={'functionsNode':!0x0,'props':_0x275593};this['_setNodeId'](_0x10b4f4,_0x2be225),this[_0x43b3d9(0x1b6)](_0x10b4f4,_0x2be225),this['_setNodeExpandableState'](_0x10b4f4),this[_0x43b3d9(0xc5)](_0x10b4f4,_0x2be225),_0x10b4f4['id']+='\\x20f',_0x194763['props'][_0x43b3d9(0x1a2)](_0x10b4f4);}}},_0x4b6695[_0xf1105(0x146)]['_addLoadNode']=function(_0x59c2cf,_0x5c7199){},_0x4b6695[_0xf1105(0x146)]['_setNodeExpandableState']=function(_0x3a2618){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x18d)]=function(_0x161e22){var _0x56bf19=_0xf1105;return Array[_0x56bf19(0x112)](_0x161e22)||typeof _0x161e22==_0x56bf19(0x12a)&&this[_0x56bf19(0x102)](_0x161e22)===_0x56bf19(0x167);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xc5)]=function(_0x4dd36f,_0x895f0e){},_0x4b6695[_0xf1105(0x146)]['_cleanNode']=function(_0x180c30){var _0x427a41=_0xf1105;delete _0x180c30[_0x427a41(0xd4)],delete _0x180c30[_0x427a41(0x125)],delete _0x180c30['_hasMapOnItsPath'];},_0x4b6695['prototype'][_0xf1105(0x12c)]=function(_0xacf1dc,_0xc0a93c){};let _0x1a4db7=new _0x4b6695(),_0x5ed964={'props':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x110)]||0x64,'elements':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x116)]||0x64,'strLength':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x173)]||0x400*0x32,'totalStrLength':_0x2d63c0['defaultLimits'][_0xf1105(0x14b)]||0x400*0x32,'autoExpandLimit':_0x2d63c0[_0xf1105(0xbe)]['autoExpandLimit']||0x1388,'autoExpandMaxDepth':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x148)]||0xa},_0x488ffc={'props':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x110)]||0x5,'elements':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x116)]||0x5,'strLength':_0x2d63c0['reducedLimits'][_0xf1105(0x173)]||0x100,'totalStrLength':_0x2d63c0['reducedLimits']['totalStrLength']||0x100*0x3,'autoExpandLimit':_0x2d63c0[_0xf1105(0x194)]['autoExpandLimit']||0x1e,'autoExpandMaxDepth':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x148)]||0x2};if(_0x3b6fce){let _0x404c58=_0x1a4db7[_0xf1105(0x140)][_0xf1105(0x163)](_0x1a4db7);_0x1a4db7[_0xf1105(0x140)]=function(_0x37de55,_0x26cce8,_0x774d4d,_0xc4a132){return _0x404c58(_0x37de55,_0x3b6fce(_0x26cce8),_0x774d4d,_0xc4a132);};}function _0x41cd13(_0x391559,_0x4c8a60,_0x10cc53,_0x13add4,_0x3812a8,_0x34b8b7){var _0x8bf13b=_0xf1105;let _0x340869,_0x362f9a;try{_0x362f9a=_0x27a290(),_0x340869=_0x2adc0c[_0x4c8a60],!_0x340869||_0x362f9a-_0x340869['ts']>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0xd8)]&&_0x340869['count']&&_0x340869[_0x8bf13b(0x150)]/_0x340869[_0x8bf13b(0x178)]<_0x184542[_0x8bf13b(0x160)]['resetOnProcessingTimeAverageMs']?(_0x2adc0c[_0x4c8a60]=_0x340869={'count':0x0,'time':0x0,'ts':_0x362f9a},_0x2adc0c[_0x8bf13b(0x199)]={}):_0x362f9a-_0x2adc0c['hits']['ts']>_0x184542[_0x8bf13b(0xcc)]['resetWhenQuietMs']&&_0x2adc0c['hits']['count']&&_0x2adc0c['hits'][_0x8bf13b(0x150)]/_0x2adc0c['hits'][_0x8bf13b(0x178)]<_0x184542['global'][_0x8bf13b(0x10e)]&&(_0x2adc0c[_0x8bf13b(0x199)]={});let _0x3a50f0=[],_0x92428a=_0x340869[_0x8bf13b(0x1a0)]||_0x2adc0c[_0x8bf13b(0x199)]['reduceLimits']?_0x488ffc:_0x5ed964,_0x24a6a1=_0x242403=>{var _0x33d1d6=_0x8bf13b;let _0xaa7ad1={};return _0xaa7ad1[_0x33d1d6(0x110)]=_0x242403['props'],_0xaa7ad1['elements']=_0x242403['elements'],_0xaa7ad1[_0x33d1d6(0x173)]=_0x242403[_0x33d1d6(0x173)],_0xaa7ad1['totalStrLength']=_0x242403['totalStrLength'],_0xaa7ad1['autoExpandLimit']=_0x242403[_0x33d1d6(0x1a6)],_0xaa7ad1[_0x33d1d6(0x148)]=_0x242403[_0x33d1d6(0x148)],_0xaa7ad1[_0x33d1d6(0x128)]=!0x1,_0xaa7ad1[_0x33d1d6(0x183)]=!_0x374cb9,_0xaa7ad1['depth']=0x1,_0xaa7ad1['level']=0x0,_0xaa7ad1['expId']=_0x33d1d6(0x171),_0xaa7ad1['rootExpression']=_0x33d1d6(0x132),_0xaa7ad1[_0x33d1d6(0x117)]=!0x0,_0xaa7ad1[_0x33d1d6(0x192)]=[],_0xaa7ad1['autoExpandPropertyCount']=0x0,_0xaa7ad1[_0x33d1d6(0x164)]=_0x2d63c0[_0x33d1d6(0x164)],_0xaa7ad1['allStrLength']=0x0,_0xaa7ad1[_0x33d1d6(0xf0)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0xaa7ad1;};for(var _0x5bd495=0x0;_0x5bd495<_0x3812a8[_0x8bf13b(0x15e)];_0x5bd495++)_0x3a50f0[_0x8bf13b(0x12b)](_0x1a4db7[_0x8bf13b(0x140)]({'timeNode':_0x391559===_0x8bf13b(0x150)||void 0x0},_0x3812a8[_0x5bd495],_0x24a6a1(_0x92428a),{}));if(_0x391559==='trace'||_0x391559===_0x8bf13b(0x1bb)){let _0x1c7378=Error[_0x8bf13b(0x1be)];try{Error['stackTraceLimit']=0x1/0x0,_0x3a50f0['push'](_0x1a4db7['serialize']({'stackNode':!0x0},new Error()[_0x8bf13b(0x17c)],_0x24a6a1(_0x92428a),{'strLength':0x1/0x0}));}finally{Error[_0x8bf13b(0x1be)]=_0x1c7378;}}return{'method':'log','version':_0x48da5d,'args':[{'ts':_0x10cc53,'session':_0x13add4,'args':_0x3a50f0,'id':_0x4c8a60,'context':_0x34b8b7}]};}catch(_0x50f884){return{'method':_0x8bf13b(0xf9),'version':_0x48da5d,'args':[{'ts':_0x10cc53,'session':_0x13add4,'args':[{'type':_0x8bf13b(0x17d),'error':_0x50f884&&_0x50f884[_0x8bf13b(0x1b0)]}],'id':_0x4c8a60,'context':_0x34b8b7}]};}finally{try{if(_0x340869&&_0x362f9a){let _0x1e55bb=_0x27a290();_0x340869[_0x8bf13b(0x178)]++,_0x340869[_0x8bf13b(0x150)]+=_0x56adc0(_0x362f9a,_0x1e55bb),_0x340869['ts']=_0x1e55bb,_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x178)]++,_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x150)]+=_0x56adc0(_0x362f9a,_0x1e55bb),_0x2adc0c[_0x8bf13b(0x199)]['ts']=_0x1e55bb,(_0x340869[_0x8bf13b(0x178)]>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0x172)]||_0x340869[_0x8bf13b(0x150)]>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0xe9)])&&(_0x340869[_0x8bf13b(0x1a0)]=!0x0),(_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x178)]>_0x184542[_0x8bf13b(0xcc)][_0x8bf13b(0x172)]||_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x150)]>_0x184542['global'][_0x8bf13b(0xe9)])&&(_0x2adc0c[_0x8bf13b(0x199)]['reduceLimits']=!0x0);}}catch{}}}return _0x41cd13;}function G(_0x608e03){var _0x301f67=_0x3bccce;if(_0x608e03&&typeof _0x608e03=='object'&&_0x608e03[_0x301f67(0x101)])switch(_0x608e03[_0x301f67(0x101)][_0x301f67(0xef)]){case _0x301f67(0x14a):return _0x608e03[_0x301f67(0x1a9)](Symbol[_0x301f67(0x1c1)])?Promise['resolve']():_0x608e03;case _0x301f67(0xe3):return Promise[_0x301f67(0xda)]();}return _0x608e03;}((_0x482a1c,_0x1f56df,_0x381e75,_0x5223ca,_0x4c2047,_0x25c77c,_0x5d01c1,_0xc877f3,_0x3cd5c3,_0x37cab3,_0x4c8a1b,_0x5ed381)=>{var _0x3b6697=_0x3bccce;if(_0x482a1c['_console_ninja'])return _0x482a1c[_0x3b6697(0xfb)];let _0x351a4c={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}};if(!X(_0x482a1c,_0xc877f3,_0x4c2047))return _0x482a1c[_0x3b6697(0xfb)]=_0x351a4c,_0x482a1c[_0x3b6697(0xfb)];let _0x5788b3=b(_0x482a1c),_0x30e432=_0x5788b3[_0x3b6697(0x13b)],_0x1e618e=_0x5788b3[_0x3b6697(0xe6)],_0x371766=_0x5788b3['now'],_0x37c13f={'hits':{},'ts':{}},_0x293551=J(_0x482a1c,_0x3cd5c3,_0x37c13f,_0x25c77c,_0x5ed381,_0x4c2047===_0x3b6697(0x1b8)?G:void 0x0),_0x4882d1=(_0x15b63f,_0x323d18,_0x3f5e52,_0x599fe2,_0x52c4b8,_0x26b20b)=>{var _0x3bd643=_0x3b6697;let _0x25dfaf=_0x482a1c[_0x3bd643(0xfb)];try{return _0x482a1c[_0x3bd643(0xfb)]=_0x351a4c,_0x293551(_0x15b63f,_0x323d18,_0x3f5e52,_0x599fe2,_0x52c4b8,_0x26b20b);}finally{_0x482a1c[_0x3bd643(0xfb)]=_0x25dfaf;}},_0x317870=_0x84c9b1=>{_0x37c13f['ts'][_0x84c9b1]=_0x1e618e();},_0x34d8c2=(_0x3fc2b3,_0x333dc0)=>{let _0x37c098=_0x37c13f['ts'][_0x333dc0];if(delete _0x37c13f['ts'][_0x333dc0],_0x37c098){let _0x3cbf03=_0x30e432(_0x37c098,_0x1e618e());_0x237f05(_0x4882d1('time',_0x3fc2b3,_0x371766(),_0x5361c8,[_0x3cbf03],_0x333dc0));}},_0x4bfac0=_0x31aa10=>{var _0x392fda=_0x3b6697,_0x139dbd;return _0x4c2047===_0x392fda(0x1b8)&&_0x482a1c[_0x392fda(0x114)]&&((_0x139dbd=_0x31aa10==null?void 0x0:_0x31aa10[_0x392fda(0x186)])==null?void 0x0:_0x139dbd[_0x392fda(0x15e)])&&(_0x31aa10[_0x392fda(0x186)][0x0]['origin']=_0x482a1c[_0x392fda(0x114)]),_0x31aa10;};_0x482a1c[_0x3b6697(0xfb)]={'consoleLog':(_0x2c9f43,_0x32505d)=>{var _0x5c63b2=_0x3b6697;_0x482a1c[_0x5c63b2(0xd2)][_0x5c63b2(0xf9)][_0x5c63b2(0xef)]!==_0x5c63b2(0x198)&&_0x237f05(_0x4882d1(_0x5c63b2(0xf9),_0x2c9f43,_0x371766(),_0x5361c8,_0x32505d));},'consoleTrace':(_0x255c8e,_0x11d324)=>{var _0x814db3=_0x3b6697,_0x1152b0,_0x1733a2;_0x482a1c[_0x814db3(0xd2)][_0x814db3(0xf9)][_0x814db3(0xef)]!==_0x814db3(0x135)&&((_0x1733a2=(_0x1152b0=_0x482a1c[_0x814db3(0x161)])==null?void 0x0:_0x1152b0[_0x814db3(0x109)])!=null&&_0x1733a2[_0x814db3(0xf0)]&&(_0x482a1c[_0x814db3(0x15c)]=!0x0),_0x237f05(_0x4bfac0(_0x4882d1('trace',_0x255c8e,_0x371766(),_0x5361c8,_0x11d324))));},'consoleError':(_0x31b51e,_0x4681db)=>{var _0xab43c0=_0x3b6697;_0x482a1c[_0xab43c0(0x15c)]=!0x0,_0x237f05(_0x4bfac0(_0x4882d1(_0xab43c0(0x1bb),_0x31b51e,_0x371766(),_0x5361c8,_0x4681db)));},'consoleTime':_0x12f1f2=>{_0x317870(_0x12f1f2);},'consoleTimeEnd':(_0x24fc5b,_0x3502f6)=>{_0x34d8c2(_0x3502f6,_0x24fc5b);},'autoLog':(_0x3ba61f,_0x428a41)=>{_0x237f05(_0x4882d1('log',_0x428a41,_0x371766(),_0x5361c8,[_0x3ba61f]));},'autoLogMany':(_0x158141,_0x35bce6)=>{var _0x1a82c3=_0x3b6697;_0x237f05(_0x4882d1(_0x1a82c3(0xf9),_0x158141,_0x371766(),_0x5361c8,_0x35bce6));},'autoTrace':(_0x29d1a9,_0x7b7474)=>{var _0x502e85=_0x3b6697;_0x237f05(_0x4bfac0(_0x4882d1(_0x502e85(0x10c),_0x7b7474,_0x371766(),_0x5361c8,[_0x29d1a9])));},'autoTraceMany':(_0x402454,_0x2083c4)=>{var _0x19bf0f=_0x3b6697;_0x237f05(_0x4bfac0(_0x4882d1(_0x19bf0f(0x10c),_0x402454,_0x371766(),_0x5361c8,_0x2083c4)));},'autoTime':(_0x36dd1d,_0x4c058c,_0x1804b2)=>{_0x317870(_0x1804b2);},'autoTimeEnd':(_0x3ef5fa,_0x409b0c,_0x4355c5)=>{_0x34d8c2(_0x409b0c,_0x4355c5);},'coverage':_0x4f70d6=>{var _0x1407e0=_0x3b6697;_0x237f05({'method':_0x1407e0(0xc0),'version':_0x25c77c,'args':[{'id':_0x4f70d6}]});}};let _0x237f05=H(_0x482a1c,_0x1f56df,_0x381e75,_0x5223ca,_0x4c2047,_0x37cab3,_0x4c8a1b),_0x5361c8=_0x482a1c['_console_ninja_session'];return _0x482a1c[_0x3b6697(0xfb)];})(globalThis,_0x3bccce(0xbf),_0x3bccce(0x118),_0x3bccce(0x14d),_0x3bccce(0x166),_0x3bccce(0x143),'1780386130683',_0x3bccce(0x11f),_0x3bccce(0xfc),'','1',_0x3bccce(0x1b3));");}catch(e){console.error(e);}};/* istanbul ignore next */function oo_oo(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleLog(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tr(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tx(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleError(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_ts(/**@type{any}**/v){try{oo_cm().consoleTime(v);}catch(e){} return v;};/* istanbul ignore next */function oo_te(/**@type{any}**/v, /**@type{any}**/i){try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v;};/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/</script>

<style lang="scss" scoped>
.image {
  width: 120px;
  position: relative;
  > span {
    position: absolute;
    top: -10px;
    right: -10px;
  }
  img {
    width: 100%;
    height: 80px;
    object-fit: cover;
  }
}
.deactive_reason {
  border: 1px solid var(--mainColor-2);
  width: 100%;
  border-radius: 10px;
  height: 7rem;
  outline: none;
  // &:focus {
  //   border: 1px solid var(--mainColor-2);
  // }
  &::placeholder {
    color: var(--mainColor-2);
  }
}

/* ====================================================
   SUPER CREATIVE EXPANDED MEAL DETAILS
   ==================================================== */
.creative-expand-td {
  padding: 16px 20px !important;
  background: #f8fafc !important;
  border-top: 1px dashed rgba(120, 61, 115, 0.15) !important;
  border-bottom: 2px solid rgba(120, 61, 115, 0.1) !important;
}

.creative-expand-card {
  position: relative;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(120, 61, 115, 0.14);
  box-shadow: 0 14px 35px -10px rgba(120, 61, 115, 0.12), 0 4px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: all 0.3s ease;

  .creative-glow-bar {
    height: 4px;
    width: 100%;
    background: linear-gradient(90deg, #783d73 0%, #a855f7 50%, #ec4899 100%);
  }
}

/* Header Area */
.expand-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 18px 24px;
  background: linear-gradient(180deg, rgba(120, 61, 115, 0.035) 0%, rgba(255, 255, 255, 0) 100%);
  border-bottom: 1px solid rgba(120, 61, 115, 0.08);

  .header-main-info {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .header-icon-box {
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(120, 61, 115, 0.12) 0%, rgba(168, 85, 247, 0.18) 100%);
    color: #783d73;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(120, 61, 115, 0.12);
    border: 1px solid rgba(120, 61, 115, 0.15);
  }

  .header-text-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .expand-title {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: #2b1129;
      letter-spacing: -0.2px;
    }

    .count-badge {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      background: linear-gradient(135deg, rgba(120, 61, 115, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%);
      color: #783d73;
      font-size: 12px;
      font-weight: 700;
      padding: 3px 10px;
      border-radius: 20px;
      border: 1px solid rgba(120, 61, 115, 0.15);
    }
  }

  .header-sub-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .sub-chip {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      font-size: 11.5px;
      font-weight: 600;
      padding: 3px 9px;
      border-radius: 8px;

      &.meal-name {
        background: #f3f4f6;
        color: #374151;
        border: 1px solid #e5e7eb;
      }
      &.unique-num {
        background: #ede9fe;
        color: #6d28d9;
        border: 1px solid #ddd6fe;
      }
      &.menu-name {
        background: #fdf2f8;
        color: #be185d;
        border: 1px solid #fbcfe8;
      }
    }
  }

  .header-controls {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .btn-expand-refresh {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    border: 1px solid rgba(120, 61, 115, 0.15);
    background: #ffffff;
    color: #783d73;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.25s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover:not(:disabled) {
      background: #783d73;
      color: #ffffff;
      transform: rotate(180deg);
      box-shadow: 0 4px 12px rgba(120, 61, 115, 0.25);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

/* Body Area */
.expand-body {
  padding: 22px 24px;
}

/* Modern Glass Table View */
.creative-table-responsive {
  overflow-x: auto;
  border-radius: 14px;
  border: 1px solid rgba(120, 61, 115, 0.12);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);

  .creative-modern-table {
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;

    thead {
      background: linear-gradient(135deg, #783d73 0%, #8c4283 100%);
      color: #ffffff;

      th {
        padding: 14px 18px;
        font-size: 13px;
        font-weight: 700;
        text-align: right;
        white-space: nowrap;
        border: none;

        &:first-child {
          border-top-right-radius: 13px;
          text-align: center;
        }
        &:last-child {
          border-top-left-radius: 13px;
          text-align: center;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f1f3f7;
        transition: all 0.2s ease;

        &:last-child {
          border-bottom: none;
        }

        &:hover:not(.skeleton-tr) {
          background-color: rgba(120, 61, 115, 0.035);
        }

        td {
          padding: 14px 18px;
          font-size: 13.5px;
          color: #374151;
          vertical-align: middle;
          border: none;

          &.td-index {
            text-align: center;

            .index-circle {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 28px;
              height: 28px;
              border-radius: 50%;
              background: #f3f4f6;
              color: #4b5563;
              font-weight: 700;
              font-size: 12px;
            }
          }

          .table-restaurant-cell {
            display: flex;
            align-items: center;
            gap: 10px;

            .table-store-logo {
              width: 38px;
              height: 38px;
              min-width: 38px;
              border-radius: 10px;
              overflow: hidden;
              border: 1px solid #e5e7eb;
              background: #f9fafb;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #783d73;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .table-store-info {
              display: flex;
              align-items: center;
              min-width: 0;
            }

            .table-store-link {
              color: #1f2937;
              font-weight: 700;
              text-decoration: none;
              display: inline-flex;
              align-items: center;
              gap: 6px;
              transition: color 0.2s;

              i {
                font-size: 11px;
                opacity: 0.6;
              }

              &:hover {
                color: #783d73;
              }
            }

            .table-store-name {
              color: #1f2937;
              font-weight: 700;
            }
          }

          .table-meal-cell {
            display: flex;
            align-items: center;
            gap: 8px;

            .meal-cell-icon {
              color: #783d73;
              font-size: 14px;
            }
          }

          .table-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            font-weight: 600;
            padding: 3px 10px;
            border-radius: 6px;

            &.pill-menu {
              background: #f0fdf4;
              color: #15803d;
            }
            &.pill-price {
              background: #fffbeb;
              color: #b45309;
            }
          }

          .table-date-cell {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            color: #6b7280;
            font-size: 12.5px;
          }

          &.td-actions {
            text-align: center;

            .btn-table-edit {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              background: linear-gradient(135deg, #783d73 0%, #90428a 100%);
              color: #ffffff;
              border: none;
              border-radius: 9px;
              padding: 7px 16px;
              font-size: 12.5px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.25s ease;
              box-shadow: 0 3px 10px rgba(120, 61, 115, 0.2);

              i {
                font-size: 13px;
              }

              &:hover {
                opacity: 0.95;
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba(120, 61, 115, 0.35);
              }
            }
          }
        }
      }
    }
  }
}

/* Skeleton Loading State for Table */
.skeleton-tr {
  td {
    padding: 12px 18px !important;
  }
}

.skeleton-table-bar {
  width: 100%;
  height: 38px;
  border-radius: 8px;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f2f5 25%, #e4e7eb 50%, #f0f2f5 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.5s infinite ease-in-out;
}

@keyframes skeletonPulse {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Empty State */
.creative-empty-state {
  text-align: center;
  padding: 36px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  .empty-icon-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(120, 61, 115, 0.08) 0%, rgba(168, 85, 247, 0.12) 100%);
    color: #783d73;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
  }

  h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #1f2937;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #6b7280;
    max-width: 400px;
  }

  .btn-creative-action {
    margin-top: 8px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #783d73 0%, #90428a 100%);
    color: #ffffff;
    border: none;
    border-radius: 10px;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(120, 61, 115, 0.2);
    transition: all 0.25s ease;

    &:hover {
      opacity: 0.95;
      box-shadow: 0 6px 18px rgba(120, 61, 115, 0.35);
    }
  }
}
</style>
